define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/on",
	"dijit/_TemplatedMixin",
	"dijit/_Widget",
	"dijit/_WidgetsInTemplateMixin",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
	"dojo/text!./ToolbarPluginGraphMetric.html"
], function(declare, lang, on, _TemplatedMixin, _Widget, _WidgetsInTemplateMixin, Action, PluginFactory, ToolbarPlugin, template) {

	return PluginFactory.declare("slicerGraphMetric", [_Widget, _TemplatedMixin, _WidgetsInTemplateMixin, ToolbarPlugin], {
		templateString: template,

		// attach points
		chartTypeWidget: null,

		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "SlicerGraphMetric",
				m_onAction: "onActionSetValue"
			});
			this.defAction.resolve();
		},

		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: toggle button to true if that is default for view
			this.inherited(arguments);

			var slicerWidget = this.getView();
			var chartTypeWidget = this.chartTypeWidget;

			slicerWidget.watch("showGraphs", lang.hitch(this, this._onShowGraphsChanged));

			slicerWidget.getDeferred().then(() => {
				var metricStore = slicerWidget.getMetricStore();
				if (metricStore) {
					chartTypeWidget.set("store", metricStore);

					this.own(on(chartTypeWidget, "change", lang.hitch(this, this.onChange)));

					// select the first item from the store
					metricStore.query({}, {count: 1, sort: [{attribute: "order"}]}).forEach(function(item) {
						var value = item[metricStore.idProperty];
						chartTypeWidget.set("value", value);
					});
				}
			});
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: disable if 'showGraphs' is false
			this._setDisabled(this.chartTypeWidget, !this.getView().get("showGraphs"));
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: user callback for when widget value changes
			this.inherited(arguments, [{graphMetricKey: value}, action]);
		},

		_onShowGraphsChanged: function(name, oldValue, newValue) {
			// summary: enable the widget if 'showGraphs' is true
			this._setDisabled(this.chartTypeWidget, !newValue);
		}
	});
});